// extracted by mini-css-extract-plugin
export default {"content":"style_content__Iqkjx","itemName":"style_itemName__vj1Yu"};